var render, staticRenderFns
import script from "./CustomerReturnDeliveryPage.vue?vue&type=script&lang=ts&"
export * from "./CustomerReturnDeliveryPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomerReturnDeliveryPage.vue"
export default component.exports